import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteSectionSuccess,
  deleteSectionFailure,
  deleteSectionStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { successNotifier } from "../../../utils/helpers";
import { deleteSectionById } from "../../../services/section";

function* deleteSection({ payload }) {
  const { id, callback } = payload;
  const response = yield call(deleteSectionById, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteSectionSuccess(raw));
    successNotifier("Section deleted successfully");

    if (callback) {
      callback();
    }
  } else {
    yield put(deleteSectionFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onDeleteSection() {
  yield takeLatest(deleteSectionStart.type, deleteSection);
}
